/* eslint-disable no-continue */
/* eslint-disable prefer-destructuring */

export const EPOS = {
    unknown: 0,
    android: 1,
    ios: 2,
    windows: 3,
    0: 'unknown',
    1: 'android',
    2: 'ios',
    3: 'windows',
};

export const SoftWare = {
    unknown: 0,
    web: 1, // web浏览器
    daoyu: 2, // 叨鱼APP
    micromessenger: 3, // 微信小程序
    alipay: 4, // 支付宝小程序
    0: 'unknown',
    1: 'web',
    2: 'daoyu',
    3: 'micromessenger',
    4: 'alipay',
};

// 获取设备平台信息
export function getHardWare() {
    const useragent = navigator.userAgent.toLowerCase();

    let hardwarePlatform = EPOS.unknown;
    if (useragent.includes('android')) {
        hardwarePlatform = EPOS.android;
    } else if (useragent.includes('windows')) {
        hardwarePlatform = EPOS.windows;
    } else if (/iphone|ipad|macintosh|ipod/.test(useragent)) {
        hardwarePlatform = EPOS.ios;
    }

    return hardwarePlatform;
}

// 获取app类型
export function getSoftWare() {
    const useragent = navigator.userAgent.toLowerCase();

    let softwarePlatform = SoftWare.unknown;
    if (useragent.includes('daoyu')) {
        softwarePlatform = SoftWare.daoyu;
    } else if (useragent.includes('micromessenger')) {
        softwarePlatform = SoftWare.micromessenger;
    } else if (useragent.includes('alipay') && window.payway === 2) {
        softwarePlatform = SoftWare.alipay;
    }

    return softwarePlatform;
}

// 获取浏览器类型
export function getBrowser() {
    const UserAgent = navigator.userAgent.toLowerCase();
    const browserInfo = {};

    const browserList = {
        Opera: UserAgent.indexOf('opera') > -1,
        IE10: UserAgent.indexOf('compatible') > -1 && UserAgent.indexOf('msie') > -1,
        IE11: !!UserAgent.match(/trident.*rv:11\./),
        Firefox: UserAgent.indexOf('firefox') > -1,
        Edge: UserAgent.indexOf('edg') > -1,
        QQBrowser: /qqbrowser/.test(UserAgent),
        UCBrowser: UserAgent.indexOf('ubrowser') > -1,
        WeixinBrowser: /micromessenger/i.test(UserAgent),
        Safari: UserAgent.indexOf('safari') > -1 && UserAgent.indexOf('chrome') === -1,
        Chrome: UserAgent.indexOf('chrome') > -1 && UserAgent.indexOf('safari') > -1,
    };

    for (let i in browserList) {
        if (!browserList[i]) continue;

        // 请注意判断顺序（有些浏览器会有多个字段）
        let versions = '';
        switch (i) {
            case 'Opera':
                versions = UserAgent.match(/opera\/([\d.]+)/)[1];
                break;
            case 'IE10':
            case 'IE11':
                versions = UserAgent.match(/(msie\s|trident.*rv:)([\w.]+)/)[2];
                break;
            case 'Firefox':
                break;
            case 'Edge':
                versions = UserAgent.match(/edge\/([\d.]+)/)[1];
                break;
            case 'QQBrowser':
                versions = UserAgent.match(/qqbrowser\/([\d.]+)/)[1];
                break;
            case 'UCBrowser':
                versions = UserAgent.match(/ubrowser\/([\d.]+)/)[1];
                break;
            case 'Safari':
                versions = UserAgent.match(/version\/([\d.]+)/)[1];
                break;
            case 'Chrome':
                for (const mt in navigator.mimeTypes) {
                    // 检测是否是360浏览器(测试只有pc端的360才起作用)
                    if (navigator.mimeTypes[mt].type === 'application/360softmgrplugin') {
                        i = '360';
                    }
                }
                versions = UserAgent.match(/chrome\/([\d.]+)/)[1];
                break;
            default:
                break;
        }
        if (versions) {
            browserInfo.type = i;
            browserInfo.versions = parseInt(versions, 10);
            break;
        }
    }

    return browserInfo;
}
